import React from 'react'
import { Badge, BadgeProps } from '@chakra-ui/react'

export type StatusType =
  | 'pending'
  | 'accepted'
  | 'expired'
  | 'active'
  | 'inactive'
  | 'completed'
  | 'failed'
  | 'processing'

interface StatusBadgeProps extends Omit<BadgeProps, 'colorScheme'> {
  status: StatusType
  variant?: 'solid' | 'subtle' | 'outline'
}

const STATUS_COLOR_MAP: Record<StatusType, string> = {
  pending: 'yellow',
  accepted: 'green',
  expired: 'red',
  active: 'green',
  inactive: 'red',
  completed: 'green',
  failed: 'red',
  processing: 'blue',
}

const STATUS_DISPLAY_MAP: Record<StatusType, string> = {
  pending: 'Pending',
  accepted: 'Accepted',
  expired: 'Expired',
  active: 'Active',
  inactive: 'Inactive',
  completed: 'Completed',
  failed: 'Failed',
  processing: 'Processing',
}

export default function StatusBadge({
  status,
  variant = 'subtle',
  children,
  ...props
}: StatusBadgeProps) {
  const colorScheme = STATUS_COLOR_MAP[status] || 'gray'
  const displayText = children || STATUS_DISPLAY_MAP[status] || status

  return (
    <Badge
      colorScheme={colorScheme}
      variant={variant}
      borderRadius="md"
      fontSize="xs"
      fontWeight="medium"
      textTransform="capitalize"
      {...props}
    >
      {displayText}
    </Badge>
  )
}

// Export constants for external use
export { STATUS_COLOR_MAP, STATUS_DISPLAY_MAP }
